import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, MoveRight } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../shadcn/components/ui/Select";
import { Button } from "../../shadcn/components/ui/Button";
import { Card } from "../../shadcn/components/ui/Card";
import { Navbar } from "../../Component/Navbar";
import propertyheropic from "../../assets/Serviceasset/propertyheropic.jpeg";
import bgImg from "../../assets/about/bg-img.png";
import propInsideItems1 from "../../assets/Serviceasset/propInsideItems1.png";
import propInsideItems2 from "../../assets/Serviceasset/propInsideItems2.png";
import propInsideItems3 from "../../assets/Serviceasset/propInsideItems3.png";
import customer from "../../assets/Serviceasset/customer-support 1.png";
import granny from "../../assets/home/prperty/bg.png";
import avatar from "../../assets/serviceProvider dashboard/messages/avatar.png";
import avatar2 from "../../assets/serviceProvider dashboard/messages/avatar2.png";
import bg2 from "../../assets/home/prperty/bg2.png";
import { Footer } from "../../Component/Footer";
import propertyicon1 from "../../assets/home/prperty/prperty/propertyicon1.png";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";

const steps = [
  {
    title: "Find a Listing",
    description:
      "Make a choice of the type of apartment you want from the list upload to our system",
    icon: <img src={propertyicon1} alt="property" />,
  },
  {
    title: "Talk to an Agent",
    description: "Our agents are available 24-hours Mon-Sun",
    icon: "💬",
  },
  {
    title: "Set the date and Move in!",
    description:
      "Make payments, get moved in! All documentation will be ready, get your move-in date",
    icon: "📅",
  },
];

const testimonials = [
  {
    text: "The Most Reliable website ever",
    description:
      "For a long time, I have been trying to find tenants for my new condo in Atlanta. I found Micasa and they are very reliable. I never have to leave my work or home, their agents handle the whole negotiations and I get my pay right away.",
    author: "Paul Cooper",
    location: "Landlord, Atlanta USA",
    avatar: avatar,
  },
  {
    text: "Reliable, Friendly, Professionals",
    description:
      "I recently moved into town and tried getting a new apartment, I met with a couple of 'agents' and they couldn't produce what I needed, then I came across Micasa on the day and got a new apartment in less than a week.",
    author: "Shelly Ann",
    location: "Tenant",
    avatar: avatar2,
  },
  {
    text: "The Most Reliable website ever",
    description:
      "For a long time, I have been trying to find tenants for my new condo in Atlanta. I found Micasa and they are very reliable. I never have to leave my work or home, their agents handle the whole negotiations and I get my pay right away.",
    author: "Paul Cooper",
    location: "Landlord, Atlanta USA",
    avatar: avatar,
  },
  {
    text: "Reliable, Friendly, Professionals",
    description:
      "I recently moved into town and tried getting a new apartment, I met with a couple of 'agents' and they couldn't produce what I needed, then I came across Micasa one day, and got a new apartment in less than a week.",
    author: "Shelly Ann",
    location: "Tenant",
    avatar: avatar2,
  },
];

const stats = [
  { number: "40+", label: "Happy Clients" },
  { number: "540+", label: "Projects Completed" },
  { number: "300", label: "Dedicated Members" },
  { number: "25+", label: "Awards Won" },
];

export default function Home() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedPrice, setSelectedPrice] = useState("");
  const [filteredProperties, setFilteredProperties] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const cityQuery = searchParams.get("city")?.toLowerCase() || "";
  const stateQuery = searchParams.get("state")?.toLowerCase() || "";
  const zipQuery = searchParams.get("zip")?.toLowerCase() || "";

  // Auto-sliding functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Simulate loading for 2 seconds

    return () => clearTimeout(timer);
  }, []);

  // ============================ api integration =========================
  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await axios.get(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/postservice-form/get-alluser"
        );
        if (response.status === 200 && response.data.postServiceFormData) {
          setProperties(response.data.postServiceFormData);
          // Extract unique locations
          const uniqueLocations = [
            ...new Set(
              response.data.postServiceFormData.map(
                (property) => property.location.address
              )
            ),
          ];
          setLocations(uniqueLocations);
        } else {
          console.error("Unexpected API response structure");
          setProperties([]);
        }
      } catch (error) {
        console.error("Error fetching properties:", error);
        setError("An error occurred while fetching properties.");
        setProperties([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  // ======= Filter searh =========
  useEffect(() => {
    setFilteredProperties(properties);
  }, [properties]);

  const handleSearch = () => {
    const filtered = properties.filter((property) => {
      return (
        (selectedLocation
          ? property.location.address === selectedLocation
          : true) &&
        (selectedType
          ? property.location.bedrooms === parseInt(selectedType)
          : true) &&
        (selectedPrice
          ? property.propertyDetails.price === selectedPrice
          : true)
      );
    });
    console.log(selectedType);
    setFilteredProperties(filtered);
  };

  const handleReset = () => {
    setSelectedLocation("");
    setSelectedType("");
    setSelectedPrice("");
    setFilteredProperties(properties);
  };

  // =============== HOME PAGE FILTER =============
  useEffect(() => {
    if (properties.length > 0) {
      const filtered = properties.filter((property) => {
        const propertyCity = property.location.city?.toLowerCase() || "";
        const propertyState = property.location.state?.toLowerCase() || "";
        const propertyZip = property.location.zip?.toLowerCase() || "";

        return (
          (cityQuery ? propertyCity.includes(cityQuery) : true) &&
          (stateQuery ? propertyState.includes(stateQuery) : true) &&
          (zipQuery ? propertyZip.includes(zipQuery) : true)
        );
      });

      setFilteredProperties(filtered);
    }
  }, [cityQuery, stateQuery, zipQuery, properties]);

  if (loading) {
    return (
      <div className="w-16 h-16 border-4 border-t-4 border-blue-500 text-xs rounded-full animate-spin flex items-center mx-auto mt-[30rem] justify-center">
        loading...
      </div>
    );
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  return (
    <>
      <Navbar />
      <main className="min-h-screen">
        {/* Hero Section */}
        <section
          className="relative md:h-[600px] h-[400px] bg-cover bg-center"
          style={{ backgroundImage: `url(${propertyheropic})` }}
        >
          <div className="absolute inset-0 bg-black/10" />
          <div className="relative z-10 container mx-auto px-4 md:pt-36 pt-20">
            <h1 className="text-4xl md:text-8xl font-semibold text-[#10375C] mb-4">
              Modern infrastructure
            </h1>
            <p className="text-[#10375C]/80 text-lg md:text-xl lg:text-2xl  md:mb-6 mb-3">
              Lorem Ipsum is a Dummy text
            </p>
            <Button
              variant="link"
              className="text-[#7415E2] hover:text-purple-500 group text-lg md:text-2xl mt-2 md:mt-10"
            >
              Explore More
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform mt-2" />
            </Button>
          </div>
        </section>

        {/* Search Section */}
        <div className="bg-[#FF57221C]">
          <section className="relative -mt-20 z-20 container mx-auto px-10">
            <img
              src={customer}
              alt="customer"
              className="absolute right-0  w-[5rem]"
            />
            <div className="bg-[#000000AD] rounded-lg shadow-xl p-10 md:px-28">
              <h2 className="md:text-3xl text-xl font-bold mb-4 text-white">
                WHAT DO YOU NEED?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <Select
                  value={selectedLocation}
                  onValueChange={setSelectedLocation}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select Location" />
                  </SelectTrigger>
                  <SelectContent>
                    {locations.map((location, index) => (
                      <SelectItem key={index} value={location}>
                        {location}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>

                <Select value={selectedType} onValueChange={setSelectedType}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select Property Type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="3">3 Bedroom Duplex</SelectItem>
                    <SelectItem value="2">2 Bedroom Flat</SelectItem>
                  </SelectContent>
                </Select>

                <Select value={selectedPrice} onValueChange={setSelectedPrice}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select Price Range" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="1000">$1000</SelectItem>
                    <SelectItem value="2000">$2000</SelectItem>
                    <SelectItem value="3000">$3000</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <Button
                onClick={handleSearch}
                className="w-1/4 absolute right-20 md:right-36 mt-4 bg-purple-600 hover:bg-purple-700"
              >
                Search
                <MoveRight
                  color="#ffffff"
                  strokeWidth={3}
                  className="ml-2"
                  size={30}
                />
              </Button>
              <Button
                onClick={handleReset}
                className="w-24 absolute right-[12rem] md:right-[30rem] mt-4 bg-gray-600 hover:bg-gray-700"
              >
                Reset
              </Button>
            </div>
          </section>

          {/* How It Works */}
          <img
            src={bgImg}
            className="absolute w-[80vw] opacity-20 top-[40rem] left-[-10rem]"
            alt=""
          />
          <div className="bg-cover z-10 ">
            <section className="md:py-20 py-10 z-10">
              <div className="container mx-auto px-4">
                <h2 className="text-2xl font-semibold text-center md:mb-12 mb-5">
                  How It Works
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 md:gap-8 gap-5">
                  {steps.map((step, index) => (
                    <div key={index} className="flex items-start space-x-4">
                      <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center text-2xl">
                        {step.icon}
                      </div>
                      <div>
                        <h3 className="font-bold text-lg mb-2">{step.title}</h3>
                        <p className="text-gray-600">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>
        </div>

        {/* Property Listings */}
        <section className="py-20 z-10">
          <div className="container mx-auto px-4 z-10">
            {filteredProperties.length === 0 ? (
              <div className="text-center text-gray-500">
                No properties found
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-20 lg:gap-10">
                {filteredProperties.map((property) => (
                  <Card
                    key={property._id}
                    id={property._id}
                    className="overflow-hidden h-[550px] w-full lg:w-[450px] md:w-[380px] shadow-xl z-20"
                  >
                    <div className="relative">
                      <img
                        src={property.uploadFiles?.[0]}
                        alt={property.propertyDetails.title}
                        className="w-full h-[300px] object-cover"
                      />
                      <span
                        className={`absolute top-4 left-4 gap-3 ${property.propertyDetails.status} text-white px-3 py-1 rounded-full text-sm flex items-center space-x-1 bg-purple-600`}
                      >
                        {property.propertyDetails.propertyType}
                      </span>
                    </div>
                    <div className="p-4">
                      <div className="flex justify-between items-center mb-4">
                        <h3 className="font-semibold text-lg mb-2">
                          {property.location.address}
                        </h3>
                        <p className="text-black text-lg">
                          $ {property.propertyDetails.price}{" "}
                          <span className="text-xs">/annum</span>
                        </p>
                      </div>
                      <div className="flex justify-between items-center mb-5">
                        <div className="flex space-x-4">
                          <button
                            className="w-8 h-8 rounded-full bg-gray-100 bg-center bg-contain"
                            style={{
                              backgroundImage: `url(${propInsideItems1})`,
                            }}
                          />
                          <button
                            className="w-8 h-8 rounded-full bg-gray-100 bg-center bg-contain"
                            style={{
                              backgroundImage: `url(${propInsideItems2})`,
                            }}
                          />
                          <button
                            className="w-8 h-8 rounded-full bg-gray-100 bg-center bg-contain"
                            style={{
                              backgroundImage: `url(${propInsideItems3})`,
                            }}
                          />
                        </div>
                      </div>
                      <Link
                        to={`/PropertyDetail/${property._id}`}
                        state={property}
                      >
                        <Button className="w-full mt-4 bg-purple-600 hover:bg-purple-700 z-20">
                          View More
                          <MoveRight
                            color="#ffffff"
                            strokeWidth={3}
                            className="ml-2"
                            size={30}
                          />
                        </Button>
                      </Link>
                    </div>
                  </Card>
                ))}
              </div>
            )}
          </div>
        </section>

        {/* Testimonials */}
        <section className="bg-[#2B124C] py-10 relative z-100">
          <img
            src={granny}
            alt="Elderly people having tea"
            className="absolute top-[-75px] right-[250px] w-[23rem] h-auto z-50 hidden lg:block"
          />
          <div className="container mx-auto px-4 relative">
            <h2 className="text-4xl font-bold text-white text-center mb-12">
              What Our Clients are Saying
            </h2>
            <div className="max-w-6xl mx-auto relative h-[400px] md:h-[350px]">
              <AnimatePresence initial={false}>
                <motion.div
                  key={currentTestimonial}
                  initial={{ opacity: 0, x: "100%" }}
                  animate={{ opacity: 1, x: "0%" }}
                  exit={{ opacity: 0, x: "-100%" }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  className="absolute w-full grid grid-cols-1 md:grid-cols-2 gap-8"
                >
                  {[0, 1].map((offset) => {
                    const index =
                      (currentTestimonial + offset) % testimonials.length;
                    return (
                      <div
                        key={index}
                        className="bg-white rounded-lg p-6 shadow-lg"
                      >
                        <h3 className="text-2xl font-bold mb-4">
                          {testimonials[index].text}
                        </h3>
                        <p className="text-gray-600 mb-6">
                          {testimonials[index].description}
                        </p>
                        <div className="flex items-center">
                          <img
                            src={testimonials[index].avatar}
                            alt={testimonials[index].author}
                            className="w-12 h-12 rounded-full mr-4"
                          />
                          <div>
                            <p className="font-semibold">
                              {testimonials[index].author}
                            </p>
                            <p className="text-sm text-gray-500">
                              {testimonials[index].location}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </motion.div>
              </AnimatePresence>
            </div>
            <div className="flex justify-center space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-colors duration-200 ${
                    currentTestimonial === index ? "bg-white" : "bg-white/30"
                  }`}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Stats */}
        <section
          className="py-20 bg-blend-color-burn bg-white/80 bg-top"
          style={{
            backgroundImage: `url(${bg2})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top",
          }}
        >
          <div className="container mx-auto px-20">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <h3 className="text-5xl font-bold mb-2">{stat.number}</h3>
                  <p className="text-gray-600 font-semibold">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
